module.exports = __webpack_public_path__ + "952c9e0803498fe60bd5fe8cdc704b4a.jpg";